import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import {
  productDetailsView,
  pushRemarketingEvent,
} from '../../shared/lib/gaEnhancedEcommerce';
import { browserHistory } from 'react-router';

import { loadProductBySeoName } from '../../../redux/modules/singleProduct';
import {
  getCategoryName,
  getSubcategoryName,
} from '../../../redux/modules/categories';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import DettaglioProdotto from './DettaglioProdotto/DettaglioProdotto';

import { FaSpinner } from 'react-icons/fa';
import { data as slogan } from '../../../../../data';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import './Prodotto.scss';
import IubendaCookieSolution from '../../../utils/iubenda';
import {
  ga4ViewItem,
  ga4ViewItemList,
} from '../../shared/lib/ga4EnhancedEcommerce';
import {
  fkmxViewItem,
  fkmxViewItemList,
} from '../../shared/lib/farmakomMetrics';

import Button from '../../shared/Button/Button';
import { loadProductsByCategory } from '../../../redux/modules/products';
import ItemSlider from '../../shared/ItemSlider/ItemSlider';
import NonDisponibile from './NonDisponibile/NonDisponibile';
import { getSHA256Hash } from '../../../utils/sha256';
import { criteoViewItem } from '../../shared/lib/criteo';
import {
  gtmToGa4ViewItem,
  gtmToGa4ViewItemList,
} from '../../shared/lib/gtmEnhancedEcommerce.js';
import { cleanImage } from '../../../utils/images.js';

class Prodotto extends Component {
  state = { ga4Viewed: false, fkmxViewed: false, checkedUrl: false };

  componentDidMount() {
    // IUBENDA
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    ///////////////////////////////////////
    // GOOGLE ANALYTICS: PRODUCT DETAILS
    setTimeout(() => {
      if (this.props.advancedGa) {
        productDetailsView(
          {
            id: this.props.product.code || '',
            name: this.props.product.name,
            category: this.props.categoryName,
            brand: this.props.product.brand,
          },
          this.props.product
        );
      }
      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('product', this.props.product);
      }
      // GTM TRACK PRODUCT VIEW
      if (
        this.props.hasGoogleTagManager &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.gtmViewItem(this.props.product);
      }
      // GA4 TRACK PRODUCT VIEW
      if (
        this.props.hasGoogleAnalytics4Advanced &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.ga4ViewItem(this.props.product);
      }
      // FKMX TRACK PRODUCT VIEW
      if (
        this.props.hasFarmakomMetrics &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.fkmxViewItem(this.props.product);
      }
      // CHECK IF THE PRODUCT IS BEING RENDERED IN THE CORRECT URL
      this.checkUrlAndRedirect('cdm');
    }, 1000);

    /////////////////////////////
    // CRITEO PRODUT DETAILS TAG
    if (this.props.hasCriteo) {
      if (this.props.product.id) {
        const oldTag = document.getElementById('criteo_product_tag');
        if (!oldTag) {
          // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
          this.renderCriteoTag();
        }
      }
    }
  }

  componentDidUpdate(oldProps, oldState) {
    if (
      this.props.product.id !== oldProps.product.id &&
      !!this.props.product.id
    ) {
      this.setState({ ga4Viewed: false, fkmxViewed: false, checkedUrl: false });
      /////////////////////////////
      // CRITEO PRODUT DETAILS TAG
      if (this.props.hasCriteo) {
        // const iubenda = new IubendaCookieSolution(
        //   this.props.hasIubendaCookieSolution
        // );
        // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        this.renderCriteoTag();
      }
      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('product', this.props.product);
      }
    }
    if (oldState.gtmViewed !== this.state.gtmViewed && !this.state.gtmViewed) {
      // GTM TRACK PRODUCT VIEW
      if (
        this.props.hasGoogleTagManager &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.gtmViewItem(this.props.product);
      }
    }
    if (oldState.ga4Viewed !== this.state.ga4Viewed && !this.state.ga4Viewed) {
      // GA4 TRACK PRODUCT VIEW
      if (
        this.props.hasGoogleAnalytics4Advanced &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.ga4ViewItem(this.props.product);
      }
    }
    if (
      oldState.fkmxViewed !== this.state.fkmxViewed &&
      !this.state.fkmxViewed
    ) {
      // FKMX TRACK PRODUCT VIEW
      if (
        this.props.hasFarmakomMetrics &&
        !!Object.keys(this.props.product || {}).length
      ) {
        this.fkmxViewItem(this.props.product);
      }
    }
    if (
      oldState.checkedUrl !== this.state.checkedUrl &&
      !this.state.checkedUrl
    ) {
      // CHECK IF THE PRODUCT IS BEING RENDERED IN THE CORRECT URL
      this.checkUrlAndRedirect('cdu');
    }
  }

  checkUrlAndRedirect = from => {
    if (!this.state.checkedUrl) {
      if (this.props.error !== '404 - Not Found') {
        if (!!this.props.product.id && !this.props.loading) {
          const {
            type,
            categorySeoName,
            subcategorySeoName,
            seoName,
          } = this.props.product;

          const correctUrl = `/${type}/${categorySeoName}/${subcategorySeoName}/${seoName}`;
          const clientUrl = this.props.router.location.pathname;

          this.setState({ checkedUrl: true });

          if (clientUrl !== correctUrl && !correctUrl.includes('undefined')) {
            if (browserHistory) {
              browserHistory.replace(correctUrl);
            }
          }
        }
      }
    }
  };

  gtmViewItem = () => {
    if (!this.state.gtmViewed) {
      const { product } = this.props;
      gtmToGa4ViewItem(product);

      if (product.boughtTogether) {
        gtmToGa4ViewItemList(product.boughtTogether, {
          id: `bought_together_${product.seoName}`,
          name: `Bought Together > ${product.seoName}`,
        });
      }

      if (product.similar) {
        gtmToGa4ViewItemList(product.similar, {
          id: `similar_products_${product.seoName}`,
          name: `Similar Products > ${product.seoName}`,
        });
      }

      this.setState({ gtmViewed: true });
    }
  };

  ga4ViewItem = () => {
    if (!this.state.ga4Viewed) {
      const { product } = this.props;
      ga4ViewItem(product);

      if (product.boughtTogether) {
        ga4ViewItemList(product.boughtTogether, {
          id: `bought_together_${product.seoName}`,
          name: `Bought Together > ${product.seoName}`,
        });
      }

      if (product.similar) {
        ga4ViewItemList(product.similar, {
          id: `similar_products_${product.seoName}`,
          name: `Similar Products > ${product.seoName}`,
        });
      }

      this.setState({ ga4Viewed: true });
    }
  };

  fkmxViewItem = () => {
    if (!this.state.fkmxViewed) {
      const { product } = this.props;

      fkmxViewItem(product);

      if (product.boughtTogether) {
        fkmxViewItemList(product.boughtTogether, {
          id: `bought_together_${product.seoName}`,
          name: `Bought Together > ${product.seoName}`,
        });
      }

      if (product.similar) {
        fkmxViewItemList(product.similar, {
          id: `similar_products_${product.seoName}`,
          name: `Similar Products > ${product.seoName}`,
        });
      }

      this.setState({ fkmxViewed: true });
    }
  };

  renderCriteoTag = async () => {
    // <!-- Criteo Product Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';
    criteoViewItem(
      this.props.criteoAccountId,
      {
        email,
        zipcode,
      },
      this.props.product
    );
    // <!-- END Criteo Product Tag -->
  };

  render() {
    let {
      product,
      error,
      loading,
      categoryName,
      subcategoryName,
      siteName,
      siteUrl,
      linkDrugsAuthorizedSite,
      linkDrugsAuthorizedSiteVet,
    } = this.props;

    const goTo = path => {
      this.props.router.push(path);
    };

    // Pagina prodotto non disponibile
    if (!loading && !!error && error.includes('404')) {
      return (
        <NonDisponibile
          category={this.props.params.category}
          subcategory={this.props.params.subcategory}
          product={this.props.params.product}
          goTo={goTo}
        />
      );
    }

    return (
      <div className="prodotto">
        <Helmet
          title={product.seoTitle ? product.seoTitle : product.name}
          meta={[
            {
              name: 'description',
              content: `${
                product.seoDescription
                  ? product.seoDescription
                  : `${siteName} - ${product.name} ${categoryName} ${subcategoryName}`
              }`,
            },
            {
              name: 'keywords',
              content: `${
                product.seoKeywords
                  ? product.seoKeywords
                  : `${product.name}, ${categoryName}, ${subcategoryName}, ${siteName}, ecommerce farmacia`
              }`,
            },
            {
              property: 'og:title',
              content: `${
                product.seoTitle
                  ? product.seoTitle
                  : `${siteName} - ${product.name} ${categoryName} ${subcategoryName}`
              }`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${
                product.seoDescription
                  ? product.seoDescription
                  : `${siteName} - ${product.name} ${categoryName} ${subcategoryName}`
              }`,
            },
            { property: 'og:image', content: cleanImage(product.image) },
            {
              property: 'og:url',
              content: `${siteUrl}/${product.type}/${product.categorySeoName}/${
                product.subcategorySeoName ? product.subcategorySeoName : '_'
              }/${product.seoName}`,
            },
          ]}
        />

        <div className="container">
          {loading && (
            <div className="loading">
              <FaSpinner className="pulse" />
            </div>
          )}
        </div>
        {!loading && product && (
          <DettaglioProdotto
            product={product}
            category={this.props.params.category}
            subcategory={this.props.params.subcategory}
            categoryName={categoryName}
            subcategoryName={subcategoryName}
            linkDrugsAuthorizedSite={linkDrugsAuthorizedSite}
            linkDrugsAuthorizedSiteVet={linkDrugsAuthorizedSiteVet}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user.data,
    product: state.singleProduct.data,
    error: state.singleProduct.error,
    loading: state.singleProduct.loading,
    categoryName: getCategoryName(state, ownProps.params.category),
    subcategoryName: getSubcategoryName(state, ownProps.params.subcategory),
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    advancedGa: state.store.data.features.advancedGa,
    linkDrugsAuthorizedSite:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSite,
    linkDrugsAuthorizedSiteVet:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSiteVet,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    uiVariantThumbnail: state.store.data.uiVariants.thumbnail,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    products: state.products.data,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Prodotto, [loadProductBySeoName])
);
